import { TableCell, StatusCell } from 'ui/tableCell';
import { RightTooltip } from 'ui/tooltip';
import { FlexSpacer } from 'ui/flexSpacer';
import { Badge } from 'ui/badge';
import noop from 'utils/noop';
import { DeepLinksAccordion } from './DeepLinksAccordion';
import { TrackingDomainsTableActionButton } from './TrackingDomainsTableActionButton';

// type ColumnProps = {
//   onDelete: () => {}, // the handler for deleting a row
//   onEdit: () => {}, // the handler for editing a row
//   onSetDefault: () => {}, // the handler for setting a tracking domain as default
// };

export const configureTrackingDomainsTableColumns = ({
  onDelete = noop,
  onEdit = noop,
  onSetDefault = noop,
}) => [
  {
    name: 'Tracking domain',
    align: 'flex-start',
    RowCell: ({ row }) => (
      <TableCell>
        <FlexSpacer>
          {row.domain}
          {row.isDefault && (
            <RightTooltip
              tooltipContent={'The default tracking domain is assigned to all new sending domains'}
            >
              <Badge>Default</Badge>
            </RightTooltip>
          )}
        </FlexSpacer>
      </TableCell>
    ),
    sortable: true,
    value: 'domain',
  },
  {
    name: 'Verified',
    align: 'flex-start',
    RowCell: ({ row }) => (
      <StatusCell
        negativeLabel="Unverified"
        positiveLabel="Verified"
        showPositiveState={row.isVerified}
      />
    ),
    sortable: true,
    value: 'isVerified',
  },
  {
    name: 'Uses HTTPS',
    align: 'flex-start',
    value: 'useHttps',
    RowCell: ({ row }) => (
      <StatusCell negativeLabel="CNAME" positiveLabel="HTTPS" showPositiveState={row.useHttps} />
    ),
  },
  {
    name: 'Deep links',
    align: 'flex-start',
    RowCell: ({ row }) => {
      return (
        <TableCell>
          <DeepLinksAccordion assetLinksExist={row.assetLinksExist} deepLinks={row.deepLinks} />
        </TableCell>
      );
    },
    sortable: true,
    value: 'deepLinks',
  },
  {
    name: '',
    sortable: false,
    align: 'flex-start',
    value: 'actionCell',
    RowCell: ({ row }) => (
      <TableCell>
        <TrackingDomainsTableActionButton
          onDelete={onDelete}
          onEdit={onEdit}
          rowData={row}
          onSetDefault={onSetDefault}
        />
      </TableCell>
    ),
  },
];
